import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ITextSlider } from './text.slider.interface';
import { NgbDateParserFormatter, NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'mlp-ng-text-slider',
    templateUrl: './text.slider.component.html',
    styleUrls: ['./text.slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

// tslint:disable:prefer-output-readonly
export class TextSliderSharedComponent implements OnInit {
    @Input() config: ITextSlider = {
        label: 'Needs a Label'
    };
    @Input() dateForDatepicker = new EventEmitter<string>();
    @Input() ngDatepickerConfig: NgbDatepickerConfig;
    toggleDtp = new EventEmitter();
    @Output() changeData = new EventEmitter<string>();
    @Output() changeDateFromDatepicker = new EventEmitter<string>();
    date: NgbDateStruct;

    constructor(private dateFormatter: NgbDateParserFormatter) {}

    ngOnInit(): void {
        this.dateForDatepicker.subscribe(date => {
            this.date = this.dateFormatter.parse(date);
        });
    }

    change(direction: string): void {
        this.changeData.emit(direction);
    }

    toggleDatepicker(): void {
        this.toggleDtp.emit();
    }

    onDateSelect(event: NgbDateStruct): void {
        this.date = event;
        this.changeDateFromDatepicker.emit(this.dateFormatter.format(event));
    }
}
